"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
var BiLoggerFactory = require("wix-bi-logger-client/dist/bi-logger-factory");
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'pblc' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = (webOrMobileLogger instanceof BiLoggerFactory) ? webOrMobileLogger : webOrMobileLogger.factory(config);
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams) {
                return _this.bi.log(logParams);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 19 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'pblc' });
    }
    ;
    /**
    * @typedef {Object} clickOnClaim10Params
    * @property {string} email - contact details email
    * @property {string} first_name - contact details fIrst name
    * @property {string} last_name - contact details last name
    * @property {number} sum - sum of claimed money
    * @property {string} token - null
    * @property {string} city - contact details city
    * @property {string} state - contact details state
    **/
    /**
     * Name: Click on 'claim 10$'. Evid: 104.
     * Event description: Event fired when user clicks 'claim my $10' after filling in details.
    
     * email - Type: string. Desc: contact details email
     *
     * first_name - Type: string. Desc: contact details fIrst name
     *
     * last_name - Type: string. Desc: contact details last name
     *
     * sum - Type: numeric. Desc: sum of claimed money
     *
     * token - Type: string.
     *
     * city - Type: string. Desc: contact details city
     *
     * state - Type: string. Desc: contact details state
     * @param {clickOnClaim10Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnClaim10 = function (params) {
        return this.bi.log(__assign({ evid: 104 }, params));
    };
    /**
    * @typedef {Object} domainPostPurchaseFlowWorkingOnItParams
    
    **/
    /**
     * Name: domain post-purchase flow -> working on it. Evid: 103.
    
    
    
     * @param {domainPostPurchaseFlowWorkingOnItParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.domainPostPurchaseFlowWorkingOnIt = function (params) {
        return this.bi.log(__assign({ evid: 103 }, params));
    };
    /**
    * @typedef {Object} preRenderedWixPageIsWasShownToUserParams
    
    **/
    /**
     * Name: pre-rendered wix page is was shown to user. Evid: 2.
    
    
    
     * @param {preRenderedWixPageIsWasShownToUserParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.preRenderedWixPageIsWasShownToUser = function (params) {
        return this.bi.log(__assign({ evid: 2 }, params));
    };
    /**
    * @typedef {Object} domainPostPurchaseFlowGotWebsiteParams
    
    **/
    /**
     * Name: domain post-purchase flow -> got website. Evid: 102.
    
    
    
     * @param {domainPostPurchaseFlowGotWebsiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.domainPostPurchaseFlowGotWebsite = function (params) {
        return this.bi.log(__assign({ evid: 102 }, params));
    };
    /**
    * @typedef {Object} clickOnShareParams
    * @property {string} button_type - Available types: Facebook/ Twitter/ Link
    **/
    /**
     * Name: Click on share. Evid: 106.
     * Event description: Event fired when user clicks on Facebook, twitter or link buttons from the Superbowl game LP.
    
     * button_type - Type: string. Desc: Available types: Facebook/ Twitter/ Link
     * @param {clickOnShareParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnShare = function (params) {
        return this.bi.log(__assign({ evid: 106 }, params));
    };
    /**
    * @typedef {Object} prerenderingClassificationStage1HomePageStartLoadingPreJsParams
    
    **/
    /**
     * Name: Prerendering classification- stage 1 - Home Page start loading pre js. Evid: 4.
     * Event description: Fired when hp html code runs, used for prerendering identification process (prefetching).
    
    
     * @param {prerenderingClassificationStage1HomePageStartLoadingPreJsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.prerenderingClassificationStage1HomePageStartLoadingPreJs = function (params) {
        return this.bi.log(__assign({ evid: 4 }, params));
    };
    /**
    * @typedef {Object} domainPostPurchaseFlowNoWebsitePageParams
    
    **/
    /**
     * Name: domain post-purchase flow -> no website page. Evid: 101.
    
    
    
     * @param {domainPostPurchaseFlowNoWebsitePageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.domainPostPurchaseFlowNoWebsitePage = function (params) {
        return this.bi.log(__assign({ evid: 101 }, params));
    };
    /**
    * @typedef {Object} clickOnContinueToWixComParams
    * @property {Url} url - url of the page from which user clicked
    **/
    /**
     * Name: Click on 'continue to wix.com'. Evid: 105.
     * Event description: Event fired when user clicks 'continue to wix.com' from the Superbowl game LP.
    
     * url - Type: url. Desc: url of the page from which user clicked
     * @param {clickOnContinueToWixComParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnContinueToWixCom = function (params) {
        return this.bi.log(__assign({ evid: 105 }, params));
    };
    /**
    * @typedef {Object} prerenderingClassificationStage2HomePageInteractionParams
    
    **/
    /**
     * Name: Prerendering classification - stage 2 - Home Page interaction. Evid: 5.
     * Event description: Fired upon any user interaction in the hp, used for stage 2 of prerendering identification process. fired only on desktop.  (prefetching).
    
    
     * @param {prerenderingClassificationStage2HomePageInteractionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.prerenderingClassificationStage2HomePageInteraction = function (params) {
        return this.bi.log(__assign({ evid: 5 }, params));
    };
    /**
    * @typedef {Object} domainPostPurchaseFlowDomainSuccessPageParams
    
    **/
    /**
     * Name: domain post-purchase flow -> domain success page. Evid: 100.
    
    
    
     * @param {domainPostPurchaseFlowDomainSuccessPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.domainPostPurchaseFlowDomainSuccessPage = function (params) {
        return this.bi.log(__assign({ evid: 100 }, params));
    };
    /**
    * @typedef {Object} pageViewParams
    * @property {undefined} utm_campaign - null
    * @property {string} experiment_id - null
    * @property {Url} http_referrer - may contain utm_campaign and experiment_id parameters
    * @property {undefined} referral - null
    **/
    /**
     * Name: page view. Evid: 1001.
    
    
     * utm_campaign - Type: campaign.
     *
     * experiment_id - Type: string.
     *
     * http_referrer - Type: url. Desc: may contain utm_campaign and experiment_id parameters
     *
     * referral - Type: se_referral.
     * @param {pageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.pageView = function (params) {
        return this.bi.log(__assign({ evid: 1001 }, params));
    };
    /**
    * @typedef {Object} clickOnWixLogoInHomepageParams
    * @property {boolean} is_countdown - parameter is TRUE when this is the first click per client_id
    **/
    /**
     * Name: Click on 'WIX' logo in homepage. Evid: 107.
     * Event description: event fires on every click on the 'wix' logo.
    
     * is_countdown - Type: bool. Desc: parameter is TRUE when this is the first click per client_id
     * @param {clickOnWixLogoInHomepageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnWixLogoInHomepage = function (params) {
        return this.bi.log(__assign({ evid: 107 }, params));
    };
    /**
    * @typedef {Object} wixPageIsBeingPreRenderedParams
    
    **/
    /**
     * Name: wix page is being pre-rendered. Evid: 1.
    
    
    
     * @param {wixPageIsBeingPreRenderedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wixPageIsBeingPreRendered = function (params) {
        return this.bi.log(__assign({ evid: 1 }, params));
    };
    /**
    * @typedef {Object} firstAnonymousParams
    * @property {undefined} utm_campaign - null
    * @property {string} experiment_id - null
    * @property {undefined} referral - null
    **/
    /**
     * Name: first anonymous. Evid: 1000.
    
    
     * utm_campaign - Type: campaign.
     *
     * experiment_id - Type: string.
     *
     * referral - Type: se_referral.
     * @param {firstAnonymousParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.firstAnonymous = function (params) {
        return this.bi.log(__assign({ evid: 1000 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
//# sourceMappingURL=index.js.map